<template>
  <div class="custom-form">
    <!-- 拖拽区域 -->
    <Attribute />
    <!-- 展示区域 -->
    <Preview
      @active="handleActive"
      :form-items="form"
      :title="title"
      ref="preview"
      @changeViewCtrl="handleChangeViewCtrl"
    />
    <!-- 右侧属性配置 -->
    <Control :formData="activeData" :isViewCtrl="isViewCtrl" />
  </div>
</template>

<script>
import Attribute from './layout/attribute'
import Control from './layout/control'
import Preview from './layout/preview'
import { outClick } from '@/util/util'
import { rules } from './rule'

export default {
  props: {
    // 初始化表格数据
    form: {
      default: () => []
    },
    // 审批流名称 取自基础信息
    title: {
      default: ''
    }
  },
  components: {
    Attribute,
    Control,
    Preview
  },
  data() {
    return {
      // 当前选中组件数据
      activeData: '',
      // 组件注销之前移除全局监听函数
      fn: '',
      // 以抽屉的方式展示选中组件详情
      isViewCtrl: false
    }
  },
  beforeDestroy() {
    outClick.prototype.remove(this.fn)
  },
  mounted() {
    // State 为真则点击了区域之外
    // 区域之外点击则关闭属性配置栏
    this.fn = outClick(['preview-item-box', 'custom-form-control', 'el-dialog__wrapper'], state => {
      this.isViewCtrl = !state
      if (state) {
        this.activeData = ''
        this.$refs.preview.currentCom = ''
        this.doSubmit()
      }
    })
  },
  methods: {
    // 展示or隐藏（属性栏）
    handleChangeViewCtrl(bool) {
      this.isViewCtrl = bool
      this.doSubmit()
    },
    // 获取选中项数据
    handleActive(params) {
      this.activeData = ''
      this.$nextTick(() => {
        this.activeData = params
      })
    },
    // 校验函数
    ruleCallBack(result) {
      return !(result instanceof Error)
    },
    // 下一步之前校验
    doSubmit() {
      let state = true
      this.form.map(item => {
        const { attribute } = item
        const keys = Object.keys(attribute)
        const cState = keys.some(el => {
          const cRules = rules[el]
          const value = item['attribute'][el]
          // 首先分不需要校验的
          if (!cRules) return false
          const rule = cRules[0]
          let valid = false
          // 普通校验
          if (rule.required) {
            valid = Boolean(value)
          }
          if (rule.validator) {
            valid = rule.validator(false, value, this.ruleCallBack)
          }
          // 自定义校验
          item.rule = valid
          return !valid
        })
        if (cState && state) state = false
        return cState
      })
      return state
    }
  }
}
</script>
